import { connect } from 'react-redux';

import Backdrop from 'components/Backdrop';
import * as actions from 'state/actions';
import AppSelector from 'state/selectors/app';
import CartSelector from 'state/selectors/cart';
import CollectionPageSelector from 'state/selectors/collection-page';
import TopNavigationSelector from 'state/selectors/top-navigation';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const mapStateToProps = state => {
  const cartIsOpen = CartSelector.getIsCartOpen(state);
  const l1ActiveNode = TopNavigationSelector.getActiveNodeAtDepth(state, 0);
  const topNavigationIsOpen = !!l1ActiveNode;
  const modalIsOpen = AppSelector.modalIsOpen(state);
  const collectionPageFilterDrawerIsOpen = CollectionPageSelector.getIsFilterDrawerOpen(state);

  return {
    cartIsOpen,
    topNavigationIsOpen,
    modalIsOpen,
    collectionPageFilterDrawerIsOpen,
  };
};

const mapDispatchToProps = dispatch => ({
  closeCart: () => dispatch(actions.closeCart()),
  closeTopNavigation: () => dispatch(actions.closeTopNavigation()),
  closeModal: () => dispatch(actions.closeModal()),
  closeCollectionPageFilterDrawer: () => dispatch(actions.closeCollectionPageFilterDrawer()),
});

const mergeProps = (stateProps, dispatchProps) => {
  let show = false;
  let label;
  let onClick;
  let zIndex;

  if (stateProps.cartIsOpen) {
    show = true;
    label = I18n.localize('cart.closeCart');
    onClick = dispatchProps.closeCart;
    zIndex = Theme.get('z-index-cart-backdrop');
  } else if (stateProps.topNavigationIsOpen) {
    show = true;
    label = I18n.localize('topNavigation.closeNavigation');
    onClick = dispatchProps.closeTopNavigation;
    zIndex = Theme.get('z-index-top-navigation-backdrop');
  } else if (stateProps.modalIsOpen) {
    show = true;
    label = I18n.localize('app.closeModal');
    onClick = dispatchProps.closeModal;
    zIndex = Theme.get('z-index-modal-backdrop');
  } else if (stateProps.collectionPageFilterDrawerIsOpen) {
    show = true;
    label = I18n.localize('cart.closeDrawer');
    onClick = dispatchProps.closeCollectionPageFilterDrawer;
    zIndex = Theme.get('z-index-collection-page-filter-drawer-backdrop');
  } else {
    show = false;
    onClick = () => {};
    zIndex = undefined;
  }

  return {
    ...stateProps,
    ...dispatchProps,
    show,
    'aria-label': label,
    onClick,
    zIndex,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Backdrop);
